/**
 * Function to convert number of outcomes to correct labels.
 *
 * @param outcomeCount number of outcomes
 * @param outcomeDistribution optional outcome distribution for labels
 * @returns Array with outcome labels and aria-labels for all outcomes
 */
export default function convertOutcomeCountToLabels(
  outcomeCount: number,
  outcomeDistribution: (string | null | undefined)[] | undefined
): {
  ariaLabel: string;
  outcome: string;
}[] {
  switch (outcomeCount) {
    default:
      return [
        {
          ariaLabel: `Utfall Ett, Hemmaseger${outcomeDistribution ? `, Svenska folket ${outcomeDistribution[0]}%` : ''}`,
          outcome: '1',
        },
        {
          ariaLabel: `Utfall Kryss, Oavgjort${outcomeDistribution ? `, Svenska folket ${outcomeDistribution[1]}%` : ''}`,
          outcome: 'X',
        },
        {
          ariaLabel: `Utfall Två, Bortaseger${outcomeDistribution ? `, Svenska folket ${outcomeDistribution[2]}%` : ''}`,
          outcome: '2',
        },
      ];
  }
}
